import { Link, useNavigate } from 'react-router-dom';
import { Bike, ShoppingBag, Store } from 'lucide-react';
import { useCart } from '../../lib/cart';
import { money } from '../../lib/format';
import { Empty } from '../../components/ui';
import { useI18n } from '../../i18n';
import { usePublic } from './context';
import { CartLineRow } from './MenuPage';

export function CartPage() {
  const { restaurant: r } = usePublic();
  const { t } = useI18n();
  const cart = useCart();
  const nav = useNavigate();
  const fee = cart.mode === 'DELIVERY' ? r.deliveryFeeCents : 0;
  const tax = Math.round(((cart.subtotalCents + fee) * r.taxRatePercent) / 100);
  const belowMin = cart.subtotalCents < r.minimumOrderCents;
  return (
    <main className="pub-main" style={{ maxWidth: 760 }}>
      <div className="card card-pad stack-lg">
        <div className="row-between wrap">
          <h1 className="section-title">{t.cart.title}</h1>
          <div className="mode-toggle light">
            <button className={cart.mode === 'DELIVERY' ? 'active' : ''} onClick={() => cart.setMode('DELIVERY')} disabled={!r.deliveryEnabled}>
              <Bike size={16} /> {t.common.delivery}
            </button>
            <button className={cart.mode === 'PICKUP' ? 'active' : ''} onClick={() => cart.setMode('PICKUP')} disabled={!r.pickupEnabled}>
              <Store size={16} /> {t.common.pickup}
            </button>
          </div>
        </div>
        {cart.lines.length === 0 ? (
          <Empty icon={<ShoppingBag size={40} />}>
            {t.cart.empty}
            <div style={{ marginTop: 14 }}>
              <Link to={`/r/${r.slug}/menu`} className="btn btn-primary">
                {t.common.viewMenu}
              </Link>
            </div>
          </Empty>
        ) : (
          <>
            <div>
              {cart.lines.map((l) => (
                <CartLineRow key={l.key} line={l} />
              ))}
            </div>
            <div className="totals">
              <div className="row-between">
                <span className="muted">{t.common.subtotal}</span>
                <span>{money(cart.subtotalCents)}</span>
              </div>
              <div className="row-between">
                <span className="muted">{t.cart.taxesQc}</span>
                <span>{money(tax)}</span>
              </div>
              {cart.mode === 'DELIVERY' && (
                <div className="row-between">
                  <span className="muted">{t.common.deliveryFee}</span>
                  <span>{money(fee)}</span>
                </div>
              )}
              <div className="row-between total">
                <span>{t.common.total}</span>
                <span>{money(cart.subtotalCents + fee + tax)}</span>
              </div>
            </div>
            {belowMin && <div className="alert alert-warn">{t.cart.minimum(money(r.minimumOrderCents))}</div>}
            <button className="btn btn-primary btn-lg btn-block" disabled={belowMin} onClick={() => nav(`/r/${r.slug}/checkout`)} data-testid="go-checkout">
              {t.menu.checkout}
            </button>
            <Link to={`/r/${r.slug}/menu`} className="btn btn-ghost btn-block">
              {t.cart.keepShopping}
            </Link>
          </>
        )}
      </div>
    </main>
  );
}
